import React, { FC } from 'react'
import CalendarInput, { ICalendarInput } from '../CalendarInput'
import CalendarForm, { ICalendarForm } from '../CalendarForm'

const CalendarInputForm: FC<ICalendarForm & ICalendarInput> = ({
  formik,
  name,
  type,
  disabled,
  clear,
  readOnly,
  onOpenPickNewDate = true,
  ...props
}) => {
  return (
    <CalendarForm
      {...props}
      formik={formik}
      name={name}
      onOpenPickNewDate={onOpenPickNewDate}
      render={<CalendarInput type={type} disabled={disabled} clear={clear} readOnly={readOnly} />}
    />
  )
}

export default CalendarInputForm
